import React from 'react';
export function PipelineLines({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} viewBox="0 0 1200 120" preserveAspectRatio="none" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" data-id="element-136">
      <g stroke="currentColor" strokeWidth="1" fill="none" opacity="0.5" data-id="element-137">
        <path d="M0 60 L300 60 L320 40 L600 40 L620 60 L900 60 L920 80 L1200 80" data-id="element-138" />
        <path d="M0 30 L200 30 L220 10 L500 10 L520 30 L1200 30" opacity="0.5" data-id="element-139" />
        <path d="M0 100 L400 100 L420 80 L800 80 L820 100 L1200 100" opacity="0.4" data-id="element-140" />
      </g>
      <g fill="currentColor" data-id="element-141">
        <circle cx="320" cy="40" r="2.5" data-id="element-142" />
        <circle cx="620" cy="60" r="2.5" data-id="element-143" />
        <circle cx="920" cy="80" r="2.5" data-id="element-144" />
      </g>
    </svg>;
}